export interface IErrors {
  [key: string]: string[];
}

export function isIErrors(obj: any): obj is IErrors {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  for (const key in obj) {
    if (!Array.isArray(obj[key]) || !obj[key].every((item: any) => typeof item === 'string')) {
      return false;
    }
  }

  return true;
}
